import { Injectable, OnDestroy } from "@angular/core";
import { BREAK_LARGE_RESOLUTION } from "android/app/src/constants/app.contants";
import { fromEvent, ReplaySubject, BehaviorSubject, Observable } from "rxjs";
import { debounceTime, takeUntil, map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class WindowService implements OnDestroy {

  public windowSize: number = window?.innerWidth;
  private destroyed$: ReplaySubject<void> = new ReplaySubject<void>();
  private windowSize$: BehaviorSubject<number> = new BehaviorSubject<number>(this.windowSize);
  public isDesktopRes$: Observable<boolean> = this.windowSize$.pipe(
    map(size => size > BREAK_LARGE_RESOLUTION)
  );

  constructor() {
    fromEvent(window, 'resize')
    .pipe(
      debounceTime(300),
      takeUntil(this.destroyed$)
    )
    .subscribe(() => {
        this.windowSize = window?.innerWidth ?? this.windowSize;
        this.windowSize$.next(this.windowSize);
    });
  }

  public get isDesktopRes(): boolean {
    return this.windowSize > BREAK_LARGE_RESOLUTION;
  }

  public get hostname(): string {
    return window?.location?.hostname ?? '';
  }

  ngOnDestroy() {
    this.destroyed$?.next();
    this.destroyed$?.complete();
    this.windowSize$.complete();
  }
}
